import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';
/* Constants */
import { PAGE_TYPE_SAFETY_AND_SUPPORT } from '@constants/pages';
/* Components */
import { getLayout } from '@components/PageLayouts/Layout/Standard';
import SafetyAndSupportPage from '@scenes/SafetyAndSupportPage/SafetyAndSupportPage';
/* Types */
import { Children } from 'types/base.types';

const SafetyAndSupport = (): Children => (
  <>
    <Head>{generateNextSeo({ title: 'Safety and Support' })}</Head>
    <SafetyAndSupportPage />
  </>
);

SafetyAndSupport.pageAttributes = { page: PAGE_TYPE_SAFETY_AND_SUPPORT };
SafetyAndSupport.Layout = getLayout({ promo: false, footer: true });

export default SafetyAndSupport;
